
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/public-api-settings",
      function () {
        return require("private-next-pages/profile/public-api-settings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/public-api-settings"])
      });
    }
  